import firebase from '../firebase-app'

export default {
  backblaze: {
    getUploadUrl: firebase.functions().httpsCallable('backblaze-uploadurl')
  }
}
